import request from '@/utils/request'
// 查询大赛作品申报动态数据列表
export function listData (url, query) {
  return request({
    url: url + '/workdata/list',
    method: 'get',
    params: query
  })
}

// 查询大赛作品申报动态数据列表
export function workList (url, query) {
  return request({
    url: url + '/workdata/selectWorkList',
    method: 'post',
    params: query
  })
}

// 查询大赛作品申报动态数据列表
export function listDataSum (url, query) {
  return request({
    url: url + '/workdata/expertListSum',
    method: 'get',
    params: query
  })
}
// 新增大赛作品申报暂存数据
export function addTemporary (url, data) {
  return request({
    url: url + '/workdata/addTemporary',
    method: 'post',
    data: data
  })
}
// 作品申报暂存作品提交到正式作品
export function addDynamicDataDelTemporaryData (url, data) {
  return request({
    url: url + '/workdata/addDynamicDataDelTemporaryData',
    method: 'post',
    data: data
  })
}

export function getWorkFile (url, id) {
  return request({
    url: url + '/workdata/getWorkFile/' + id,
    method: 'get',
    params: id
  })
}

// 修改大赛作品追暂存数据
export function editTemporary (url, data) {
  return request({
    url: url + '/workdata/editTemporary',
    method: 'post',
    data: data
  })
}
// 查询大赛作品申报动态数据详细
export function getData (url, id) {
  return request({
    url: url + '/workdata/' + id,
    method: 'get'
  })
}

// 查询大赛作品暂存数据
export function listTemporary (url, query) {
  return request({
    url: url + '/workdata/listTemporary',
    method: 'get',
    params: query
  })
}
// 查询大赛作品暂存数据（全部）
export function listTemporaryAll (query) {
  return request({
    url: '/ruoyi-site/workdata/listTemporaryAll',
    method: 'get',
    params: query
  })
}
// 更新flowId
export function updateFlowIdSum (url, query) {
  return request({
    url: url + '/workdata/updateFlowIdSum',
    method: 'post',
    data: query
  })
}

// 更新flowId
export function updateFlowId (url, query) {
  return request({
    url: url + '/workdata/updateFlowId',
    method: 'post',
    data: query
  })
}
// 批量更新flowId
export function batchUpdateFlowId(url,query) {
  return request({
    url: url+'/workdata/batchUpdateFlowId',
    method: 'post',
    data: query
  })
}

// 查询大赛作品申报动态数据详细
export function  getContWorkDynamicDataFlowVoById (url, id) {
  return request({
    url: url + '/workdata/getContWorkDynamicDataFlowVoById/' + id,
    method: 'get'
  })
}
// 查询大赛作品申报动态数据列表(已评分)
export function listDataReviewSum(url,query) {
  return request({
    url: url+'/workdata/ReviewExpertListSum',
    method: 'get',
    params: query
  })
}
//获取专家审批数据（作品类型，作品数量）
export function selectWorkCategorySum(url, query) {
  return request({
    url: url + '/workdata/selectWorkCategorySum',
    method: 'post',
    params: query
  })
}

// 审核查询大赛作品申报动态数据详细
export function getContWorkDynamicDataFlowVoByIdForAudited(url,query) {
  return request({
    url: url + '/workdata/getContWorkDynamicDataFlowVoByIdForAudited',
    method: 'post',
    params: query
  })
}

// 删除大赛作品申报暂存数据
export function removeTemporary (url, id) {
  return request({
    url: url + '/workdata/removeTemporary/' + id,
    method: 'delete'
  })
}

// 新增大赛作品申报动态数据
export function addData (url, data) {
  return request({
    url: url + '/workdata',
    method: 'post',
    data: data
  })
}

// 修改大赛作品申报动态数据
export function updateData (url, data) {
  return request({
    url: url + '/workdata',
    method: 'put',
    data: data
  })
}

// 删除大赛作品申报动态数据
export function delData (url, id) {
  return request({
    url: url + '/workdata/' + id,
    method: 'delete'
  })
}

// 查询大赛作品申报动态数据详细
export function selectContExpertGroupByExpertId (url, expertId, siteId) {
  return request({
    url: url + '/actuator/expertGroup/selectContExpertGroupByExpertId/' + expertId + '/' + siteId,
    method: 'get',
    param:expertId,siteId
  })
}
// 查询专家与作品列表中的赛区信息
export function selectExpertGroupDivision (url, expertId, siteId) {
  return request({
    url: url + '/actuator/expertGroup/selectExpertGroupDivision/' + expertId + '/' + siteId,
    method: 'get',
    param:expertId,siteId
  })
}

//查询表单数据是否合法，主要校验文件上传互斥
export function checkFormData(url,language,data) {
  return request({
    url: url+'/ruoyi-site/workdata/checkFormData/'+language,
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/work/workdata.js